import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import '../Connect/Connect.css';

const Connect = () => {
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    mobile: '',
    requirements: ''
  });
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
    validate(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!Object.values(formErrors).some((error) => error !== '')) {
      setIsSending(true);

      emailjs.send(
        'service_gvm17f',
        'template_gxnefr',
        formValues,
        'JAs-KO2PXFGVuHdx'
      )
      .then((response) => {
        Swal.fire({
          title: 'Inquiry Sent!',
          text: 'Thank you for your interest in our orthopedic packaging solutions. We’ll contact you shortly.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        setIsSending(false);
        setFormValues({ name: '', email: '', mobile: '', requirements: '' });
      })
      .catch((error) => {
        Swal.fire({
          title: 'Error!',
          text: 'There was an issue sending your message. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        setIsSending(false);
      });
    }
  };

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'name':
        errors.name = /^[A-Za-z\s]+$/.test(value) ? '' : 'Name should contain only alphabets.';
        break;
      case 'email':
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address.';
        break;
      case 'mobile':
        errors.mobile = /^\d{10}$/.test(value) ? '' : 'Mobile number should be 10 digits.';
        break;
      case 'requirements':
        errors.requirements = value.length >= 15 ? '' : 'Please provide more details (min 15 characters).';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  return (
    <section className="connect">
      <div className="left-con">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d448193.9510803386!2d76.76354916726658!3d28.644287341781194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x37205b715389640!2sDelhi!5e0!3m2!1sen!2sin!4v1748870826016!5m2!1sen!2sin" 
          width="100%" 
          height="100%" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy"
          title="Office Location">
        </iframe>
      </div>
      <div className="right-con">
        <h2>Get in Touch</h2>
        <p className="intro-text">
          Interested in our orthopedic instruments packaging? 
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input 
              type="text" 
              id="name" 
              autoComplete='off'
              name="name" 
              value={formValues.name} 
              onChange={handleChange} 
              required 
            />
            {formErrors.name && <p className="error">{formErrors.name}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input 
              type="email" 
              id="email" 
              autoComplete='off'
              name="email" 
              value={formValues.email} 
              onChange={handleChange} 
              required 
            />
            {formErrors.email && <p className="error">{formErrors.email}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="mobile">Mobile Number</label>
            <input 
              type="tel" 
              id="mobile" 
              autoComplete='off'
              name="mobile" 
              value={formValues.mobile} 
              onChange={handleChange} 
              required 
            />
            {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="requirements">Packaging Requirements</label>
            <textarea 
              id="requirements" 
              name="requirements" 
              autoComplete='off'
              value={formValues.requirements} 
              onChange={handleChange} 
              rows="4" 
              required 
              placeholder="Describe instrument types, dimensions, quantity, etc.">
            </textarea>
            {formErrors.requirements && <p className="error">{formErrors.requirements}</p>}
          </div>

          <button className="send-button" type="submit" disabled={isSending}>
            {isSending ? 'Sending...' : 'Send Inquiry'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Connect;
